import React, {ReactNode} from "react";
import {InputAdornmentProps} from "@material-ui/core/InputAdornment";
import {DatePicker, NumberTextField} from "../../formikFormInputs";
import moment from "moment";
import {usePolicyContext} from "./PolicyContext";
import {useFormikContext} from "formik";
import {Label} from "../../formInputs";
import numeral from "numeral";
import {useActions} from "../../../actions";
import * as PaymentActions from "../../../actions/payment";
import {PaymentFrequency} from "./index";
import {InpAdornment} from "../../Common";
import PaymentBreakdownMonthly from "./PaymentBreakdownMonthly";
import PaymentBreakdownAnnual from "./PaymentBreakdownAnnual";
import {isDebug} from "../../../utils/commonUtils";


export const DMC:string = "flexiPayments"

type Payment = {
    amount: number;
    date: string;
    paymentId: string;
    inx: number;
    status: number;
}

type UpdatePayment = {
    amount: number;
    date:string;
    paymentId:string;
}

export type ContributionField = {
    allowNegative?: boolean;
    className?: string;
    component: React.ComponentType<any>;
    disablePast?:boolean;
    filedType: string;
    id: string;
    InputProps?: { startAdornment?: React.ReactElement<InputAdornmentProps>; };
    isRequired: boolean;
    label: ReactNode;
    name: string;
    variant: "outlined" | "filled" | "standard";
};

const FlexiPayments = (props:{year:number, frequency:string, paymentData:[]}) => {
    const {policy, refetchPolicy} = usePolicyContext();
    const [saveIndexIds, setSaveIndexIds] = React.useState<number[]>([]);
    const {year, frequency, paymentData} = props;
    const payment = useActions(PaymentActions);
    const {values}: any = useFormikContext();
    const contributionFields: ContributionField[] = [
        {
            allowNegative: false,
            component: NumberTextField,
            filedType: "number",
            id: "amount",
            InputProps: {
                startAdornment: <InpAdornment children="$" className="margin0 dollerIcon" position="start" />
            },
            isRequired: true,
            label: (
                    <Label label={frequency === PaymentFrequency.Monthly ? "Excepted Monthly Contribution" : "Excepted annual Contribution"}/>
            ),
            name: "amount",
            variant: "outlined",
        },
        {
            component: DatePicker,
            filedType: "number",
            id: "date",
            isRequired: true,
            label: <Label label={"Contribution Due Date"} />,
            name: "date",
            variant: "outlined",
        }
    ];

    const handlePaymentSave = async () => {
        const fPayload:Payment[] = [];
        values && values["flexiPayments"].map((d:Payment) => {
            if (!d) {
                return;
            }

            fPayload.push({...d, amount: numeral(d.amount).value(), date: moment(d.date).format("YYYY-MM-DD")});
        })
        const payload: UpdatePayment[] = fPayload.filter((s) => saveIndexIds.includes(s.inx))
                .map(p => ({amount: p.amount, date: p.date, paymentId: p.paymentId}));

        if (isDebug()) {
            console.info(payload);
            alert(JSON.stringify(payload));
        }

        await payment.updateFlexiPayment(payload, {policyID: policy.policyNumber});
        await refetchPolicy();
    }

    return (
            <React.Fragment>
                {frequency === PaymentFrequency.Monthly ? (
                        <PaymentBreakdownMonthly
                                fields={contributionFields}
                                frequency={frequency}
                                handlePaymentSave={handlePaymentSave}
                                paymentData={paymentData}
                                saveIndexIds={saveIndexIds}
                                setSaveIndexIds={setSaveIndexIds}
                                year={year}
                        />
                ) : frequency === PaymentFrequency.Annual ? (
                        <PaymentBreakdownAnnual
                                fields={contributionFields}
                                frequency={frequency}
                                handlePaymentSave={handlePaymentSave}
                                paymentData={paymentData}
                                saveIndexIds={saveIndexIds}
                                setSaveIndexIds={setSaveIndexIds}
                                year={year}
                        />
                ) : (
                        <div>No valid frequency selected</div>
                )}
            </React.Fragment>
    );
};

export default FlexiPayments;